import { Button, Flex } from '@utilitywarehouse/hearth-react';

import './styles.scss';

interface NavBarProps {
  continueLabel?: string;
  continueDisabled?: boolean;
  onContinue: (event: React.MouseEvent<HTMLButtonElement>) => void;
  backLabel?: string;
  onBack: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const NavBar = ({
  continueLabel = 'Continue',
  continueDisabled = false,
  onContinue,
  backLabel = 'Back',
  onBack,
}: NavBarProps) => (
  <Flex alignItems="center" className="inLifeNavBar">
    <Flex
      className="wrapper inLifeNavBar__actions"
      direction="row"
      spacing="lg"
      justifyContent="end"
    >
      <Button
        type="button"
        variant="outline"
        size="md"
        data-testid="inlife-navbar-back-button"
        onClick={onBack}
      >
        {backLabel}
      </Button>
      <Button
        type="submit"
        size="md"
        data-testid="inlife-navbar-continue-button"
        onClick={onContinue}
        disabled={continueDisabled}
      >
        {continueLabel}
      </Button>
    </Flex>
  </Flex>
);

export type { NavBarProps };
export { NavBar };
